// extracted by mini-css-extract-plugin
export default {"container":"SocialIcons_container__ewBGJ","sprite":"SocialIcons_sprite__lQJ71","title":"SocialIcons_title__LC8dm"};